module.exports = __webpack_public_path__ + "img/img_supplier_meidi@2x.bf50925c.png";